// import React from 'react'
// import styled, { keyframes, ThemeProvider } from 'styled-components'
// import { darkTheme } from "./Themes";
// import { motion } from "framer-motion";

// import LogoComponent from "../subComponents/LogoComponent";
// import SocialIcons from "../subComponents/SocialIcons";
// import PowerButton from "../subComponents/PowerButton";
// import ParticleComponent from '../subComponents/ParticleComponent';

// import astronaut from '../assets/Images/spaceman.png';
// import BigTitle from '../subComponents/BigTitle';



// const Box = styled.div`
//   background-color: ${(props) => props.theme.body};
//   width: 100vw;
//   height: 100vh;
//   position: relative;
//   overflow: hidden;
// `

// const float = keyframes`
//   0% { transform: translateY(-10px); }
//   50% { transform: translateY(15px) translateX(15px); }
//   100% { transform: translateY(-10px); }
// `

// const Spaceman = styled.div`
//   position: absolute;
//   top: 10%;
//   right: 5%;
//   width: 20vw;
//   animation: ${float} 4s ease infinite; 

//   img {
//     width: 100%;
//     height: auto;
//     cursor: pointer;
//   }

//   @media (max-width: 768px) {
//     width: 30vw;
//     top: 5%;
//     right: 5%;
//   }
// `
// const Content = styled.div`
//   flex: 1;
//   overflow-y: auto;
//   padding-right: 1rem;
//   font-size: calc(0.6rem + 1vw);

//   /* Fancy scrollbar */
//   --scrollbar-thumb-color: ${props => props.theme.text};

//   &::-webkit-scrollbar {
//     width: 6px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background: var(--scrollbar-thumb-color);
//     border-radius: 6px;
//     transition: background 0.3s ease-in-out;
//   }

//   &::-webkit-scrollbar-track {
//     background: transparent;
//   }
// `;

// const Main = styled.div`
//   border: 2px solid ${(props) => props.theme.text};
//   color: ${(props) => props.theme.text};
//   padding: 2rem;
//   width: 50vw;
//   height: 60vh;
//   z-index: 3;
//   line-height: 1.5;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   font-size: calc(0.6rem + 1vw);
//   backdrop-filter: blur(4px);
//   position: absolute;
//   left: calc(5rem + 5vw);
//   top: 55%;
//   transform: translateY(-50%);
//   font-family: 'Ubuntu Mono', monospace;
//   font-style: italic;

//   @media (max-width: 768px) {
//     width: 80vw;
//   height: auto;

//     left: 50%;
//     transform: translate(-50%, -50%);
//     padding: 1.5rem;
//     font-size: calc(0.5rem + 1vw);
//   }
// `

// // Framer Motion Animation Variants
// const pageVariants = {
//   initial: { opacity: 0, x: -50 },
//   animate: { opacity: 1, x: 0, transition: { duration: 0.5 } },
//   exit: { opacity: 0, x: 50, transition: { duration: 0.5 } },
// };

// const AboutPage = () => {
//   return (
//     <ThemeProvider theme={darkTheme}>
//       <motion.div
//         initial="initial"
//         animate="animate"
//         exit="exit"
//         variants={pageVariants}
//       >
//         <Box>
//           <LogoComponent theme='dark' />
//           <SocialIcons theme='dark' />
//           <PowerButton />
//           <ParticleComponent theme='dark'/>
//           <Spaceman>
//             <img src={astronaut} alt='SpaceMan' />
//           </Spaceman>
//           <Main>
   

//             <Content>
//               I'm Edward Ndiyo, a full-stack developer with <b>over four years of experience</b> building scalable web applications and intelligent systems. I hold an ADSE diploma and an Associate degree in Computer Science, and I’m currently completing my BSc with a few semesters to go. My work sits at the intersection of backend engineering, AI integration, and emerging embedded systems.
//               <br /> <br />
//               I’m driven by a deep curiosity for how systems think, behave, and scale. Lately, my focus has shifted toward building smarter, more autonomous solutions—where software doesn’t just respond, but anticipates. I build with intention: clean architecture, efficient logic, and a bias for real-world impact.
//               <br /> <br />
//               I also operate under the alias <b>'Paradox'</b>—a personal brand that captures how I approach problems: questioning assumptions, exploring edge cases, and finding clarity where things seem contradictory.
//               <br /> <br />
//               Outside of code, I play chess—less for the game, more for the discipline it teaches: patience, positioning, and thinking a few moves ahead. If you're building something ambitious or unconventional, we’ll probably get along. Reach out.
//             </Content>
            

//           </Main>
//           <BigTitle text='ABOUT' top='10%' left='5%' />
//         </Box>
//       </motion.div>
//     </ThemeProvider>
//   );
// }

// export default AboutPage;






import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'
import { motion } from 'framer-motion'
import { useSearchParams } from 'react-router-dom'
import { darkTheme } from './Themes'

import LogoComponent from '../subComponents/LogoComponent'
import SocialIcons from '../subComponents/SocialIcons'
import PowerButton from '../subComponents/PowerButton'
import ParticleComponent from '../subComponents/ParticleComponent'
import BigTitle from '../subComponents/BigTitle'

import astronaut from '../assets/Images/spaceman.png'

// EDIT: your real contact link
const CONTACT = 'mailto:ndiyoedward@gmail.com'

/* ---------- layout ---------- */

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  padding: 8rem 2rem 4rem calc(5rem + 5vw);

  @media (max-width: 900px) {
    padding: 9rem 1rem 3rem;
  }
`

const Shell = styled.div`
  position: relative;
  z-index: 3;
  width: min(52vw, 780px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.8rem;

  @media (max-width: 900px) {
    width: 100%;
  }
`

const float = keyframes`
  0%   { transform: translateY(-10px); }
  50%  { transform: translateY(15px) translateX(15px); }
  100% { transform: translateY(-10px); }
`

const Spaceman = styled.div`
  position: fixed;
  top: 10%;
  right: 5%;
  width: 20vw;
  z-index: 1;
  pointer-events: none;
  animation: ${float} 4s ease infinite;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 900px) {
    width: 22vw;
    top: 4.5rem;
    right: 1rem;
    opacity: 0.9;
  }
`

/* ---------- tabs ---------- */

const TabBar = styled.div`
  display: flex;
  gap: 0.4rem;
  padding: 0.3rem;
  border: 1px solid ${(props) => props.theme.text};
  border-radius: 999px;
  backdrop-filter: blur(4px);
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }
`

const Tab = styled.button`
  position: relative;
  flex-shrink: 0;
  padding: 0.55rem 1.3rem;
  background: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-family: 'Ubuntu Mono', monospace;
  font-size: 0.95rem;
  color: ${(props) => (props.$active ? props.theme.body : props.theme.text)};
  transition: color 0.3s ease;

  span { position: relative; z-index: 1; }

  @media (max-width: 600px) {
    padding: 0.45rem 0.9rem;
    font-size: 0.85rem;
  }
`

const Pill = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: ${(props) => props.theme.text};
  border-radius: 999px;
`

/* ---------- panel ---------- */

const Panel = styled(motion.div)`
  width: 100%;
  padding: 2.2rem;
  border: 2px solid ${(props) => props.theme.text};
  border-radius: 0 50px 0 50px;
  color: ${(props) => props.theme.text};
  backdrop-filter: blur(4px);
  font-family: 'Ubuntu Mono', monospace;
  line-height: 1.6;

  @media (max-width: 768px) {
    padding: 1.4rem 1.1rem;
    border-radius: 0 30px 0 30px;
  }
`

const Eyebrow = styled.div`
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  opacity: 0.6;
  margin-bottom: 0.6rem;
`

const Heading = styled.h1`
  font-size: calc(1.4em + 1.2vw);
  margin-bottom: 0.4rem;
`

const Roles = styled.p`
  font-size: calc(0.75em + 0.3vw);
  opacity: 0.7;
  margin-bottom: 1.4rem;
`

const Text = styled.p`
  font-family: 'Karla', sans-serif;
  font-size: calc(0.85em + 0.35vw);
  line-height: 1.7;
  margin-bottom: 1.1rem;
  max-width: 68ch;

  b { font-weight: 700; }
`

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.4rem 0 1.4rem;
`

const Chip = styled.span`
  padding: 0.3rem 0.85rem;
  border: 1px solid ${(props) => props.theme.text};
  border-radius: 999px;
  font-size: 0.85rem;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.text};
    color: ${(props) => props.theme.body};
  }
`

const StatRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
  margin-top: 1.2rem;
`

const Stat = styled.div`
  padding: 1rem;
  border: 1px dashed ${(props) => props.theme.text};
  border-radius: 0 20px 0 20px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 0 24px rgba(255, 255, 255, 0.12);
  }

  strong {
    display: block;
    font-size: calc(1.2em + 0.8vw);
  }

  span {
    font-size: 0.75rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    opacity: 0.7;
  }
`

/* ---------- Paradox_HQ ---------- */

const blink = keyframes`
  0%, 49%   { opacity: 1; }
  50%, 100% { opacity: 0; }
`

const Brand = styled.h2`
  font-size: calc(1.4em + 1.2vw);
  letter-spacing: 0.06em;

  &::after {
    content: '';
    display: inline-block;
    width: 0.5em;
    height: 1em;
    margin-left: 0.25em;
    vertical-align: text-bottom;
    background: ${(props) => props.theme.text};
    animation: ${blink} 1s steps(1) infinite;
  }
`

/* pan-African accent line: green / gold / red */
const AfroLine = styled.div`
  height: 4px;
  width: 140px;
  margin: 0.8rem 0 1.4rem;
  border-radius: 4px;
  background: linear-gradient(90deg, #1fa24a 0 33%, #f5b82e 33% 66%, #d7263d 66% 100%);
`

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1.1rem;
  margin-top: 1.2rem;
`

const Product = styled(motion.div)`
  padding: 1.2rem;
  border: 1px ${(props) => (props.$soon ? 'dashed' : 'solid')} ${(props) => props.theme.text};
  border-radius: 0 24px 0 24px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  opacity: ${(props) => (props.$soon ? 0.75 : 1)};

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 0 24px rgba(255, 255, 255, 0.12);
  }

  h3 {
    font-size: 0.8rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    margin-bottom: 0.6rem;
  }

  h3::before { content: '✦ '; }

  p {
    font-family: 'Karla', sans-serif;
    font-size: calc(0.8em + 0.3vw);
    line-height: 1.6;
  }
`

/* ---------- footer CTA ---------- */

const Cta = styled.a`
  display: inline-block;
  padding: 0.75rem 1.6rem;
  border: 1px solid ${(props) => props.theme.text};
  border-radius: 8px;
  text-decoration: none;
  color: ${(props) => props.theme.text};
  font-family: 'Ubuntu Mono', monospace;
  letter-spacing: 0.08em;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.text};
    color: ${(props) => props.theme.body};
  }
`

/* ---------- animation ---------- */

const pageVariants = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, x: 50, transition: { duration: 0.5 } },
}

const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, staggerChildren: 0.1 } },
}

const blockVariants = {
  hidden: { opacity: 0, y: 15 },
  show: { opacity: 1, y: 0 },
}

/* ---------- tab content ---------- */

const TABS = [
  { key: 'pilot', label: 'The Pilot' },
  { key: 'hq', label: 'Paradox_HQ' },
  { key: 'offduty', label: 'Off Duty' },
]

const Pilot = () => (
  <>
    <motion.div variants={blockVariants}>
      <Eyebrow>Transmission 01 · Origin</Eyebrow>
      <Heading>Edward Ndiyo</Heading>
      <Roles>Full-stack developer · AI automation · Embedded systems</Roles>
    </motion.div>

    <motion.div variants={blockVariants}>
      <Text>
        I'm a full-stack developer with <b>over four years of experience</b> building scalable web
        applications and intelligent systems. My work sits at the intersection of backend
        engineering, AI integration, and emerging embedded systems.
      </Text>
      <Text>
        I'm driven by a deep curiosity for how systems think, behave, and scale. Lately my focus
        has shifted toward smarter, more autonomous solutions, where software doesn't just
        respond, but anticipates. I build with intention: clean architecture, efficient logic, and
        a bias for real-world impact.
      </Text>
      <Chips>
        <Chip>ADSE Diploma</Chip>
        <Chip>Associate Degree · Computer Science</Chip>
        <Chip>BSc · Computer Science</Chip>
        <Chip>MSc · Artificial Intelligence - coming soon</Chip>
      </Chips>
    </motion.div>

    <motion.div variants={blockVariants}>
      <StatRow>
        <Stat><strong>4+</strong><span>Years building</span></Stat>
        <Stat><strong>3</strong><span>Core disciplines</span></Stat>
        <Stat><strong>1</strong><span>Startup in orbit</span></Stat>
      </StatRow>
    </motion.div>
  </>
)

const HQ = () => (
  <>
    <motion.div variants={blockVariants}>
      <Eyebrow>Transmission 02 · The Venture</Eyebrow>
      <Brand>PARADOX_HQ</Brand>
      <AfroLine />
      <Text>
        An <b>AI automation consultancy with a pan-African soul</b>. We help businesses hand the
        repetitive work to intelligent workflows, and we build creative products that speak to
        Africa in its own voice.
      </Text>
    </motion.div>

    <ProductGrid>
      <Product variants={blockVariants}>
        <h3>AI Automation Consulting</h3>
        <p>
          We map how your business really runs, then ship AI-powered workflows that handle the
          routine on their own, so your team can focus on what only humans can do.
        </p>
      </Product>

      <Product variants={blockVariants}>
        <h3>Animation Studio</h3>
        <p>
          AI-generated animated content starring original Nigerian characters: marketing videos,
          ads and stories with the humour, language and flavour of the people they're made for.
        </p>
      </Product>

      <Product variants={blockVariants}>
        <h3>Software Development</h3>
        <p>
          Custom software solutions tailored to your business needs, built with modern technologies
          and best practices.
        </p>
      </Product>

      {/* <Product variants={blockVariants} $soon>
        <h3>More in orbit</h3>
        <p>Additional products are in development. Launch sequence initiated.</p>
      </Product> */}
    </ProductGrid>
  </>
)

const OffDuty = () => (
  <>
    <motion.div variants={blockVariants}>
      <Eyebrow>Transmission 03 · Off Duty</Eyebrow>
      <Heading>The Paradox mindset</Heading>
      <Text>
        <b>Paradox</b> is the name I've worked under for a while, and it captures how I approach
        problems: questioning assumptions, exploring edge cases, and finding clarity where things
        seem contradictory. It's now the name of the venture too.
      </Text>
    </motion.div>

    <ProductGrid>
      <Product variants={blockVariants}>
        <h3>Question assumptions</h3>
        <p>The obvious answer is usually a good starting point, rarely the final one.</p>
      </Product>
      <Product variants={blockVariants}>
        <h3>Chase the edge cases</h3>
        <p>Systems are judged by how they behave when things go wrong, not when they go right.</p>
      </Product>
      <Product variants={blockVariants}>
        <h3>Play chess</h3>
        <p>
          Less for the game, more for the discipline: patience, positioning, and thinking a few
          moves ahead.
        </p>
      </Product>
    </ProductGrid>
  </>
)

const CONTENT = { pilot: Pilot, hq: HQ, offduty: OffDuty }

/* ---------- page ---------- */

const AboutPage = () => {
  const [params, setParams] = useSearchParams()
  const requested = params.get('tab')
  const activeKey = TABS.some((t) => t.key === requested) ? requested : 'pilot'
  const Active = CONTENT[activeKey]

  const selectTab = (key) => setParams({ tab: key }, { replace: true })

  return (
    <ThemeProvider theme={darkTheme}>
      <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants}>
        <Box>
          <LogoComponent theme="dark" />
          <SocialIcons theme="dark" />
          <PowerButton />
          <ParticleComponent theme="dark" />

          <Spaceman>
            <img src={astronaut} alt="SpaceMan" />
          </Spaceman>

          <Shell>
            <TabBar>
              {TABS.map((t) => (
                <Tab key={t.key} $active={activeKey === t.key} onClick={() => selectTab(t.key)}>
                  {activeKey === t.key && <Pill layoutId="about-pill" />}
                  <span>{t.label}</span>
                </Tab>
              ))}
            </TabBar>

            <Panel key={activeKey} variants={panelVariants} initial="hidden" animate="show">
              <Active />
            </Panel>

            <Text style={{ fontFamily: "'Ubuntu Mono', monospace", fontStyle: 'italic' }}>
              If you're building something ambitious or unconventional, we'll probably get along.
            </Text>
            <Cta href={CONTACT}>Reach out →</Cta>
          </Shell>

          <BigTitle text="ABOUT" top="10%" left="5%" />
        </Box>
      </motion.div>
    </ThemeProvider>
  )
}

export default AboutPage